import { createBrowserHistory } from 'history'; // eslint-disable-line

export default createBrowserHistory();
